import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { UserStoreService } from '@auth/store/services/user-store.service';
import { RpcRoute } from '@core-layout/app/models/rpc-route';
import { RouteService } from '@core-layout/app/services/route.service';

@Injectable({ providedIn: 'root' })
export class AgentSelectionGuard implements CanActivate, CanActivateChild {

    constructor(
        private readonly routeService: RouteService,
        private readonly userStoreService: UserStoreService
    ) { }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.canActivateRoute(state);
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.canActivateRoute(state);
    }

    private canActivateRoute(state: RouterStateSnapshot): Observable<boolean> {
        return this.userStoreService.selectLoginProcessData$
            .pipe(
                take(1),
                switchMap(processData => {
                    if (processData != null) {
                        return of(true);
                    }

                    this.routeService.navigate(RpcRoute.Login).catch(() => { });
                    return of(false);
                })
            );
    }
}